module.exports = __webpack_public_path__ + "static/collingwood-logo-911cbda5f8c7d8f71809547469e30a00.gif";